import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const staff = [
  {
    path: '/staff/employee',
    name: 'staff-employee-list',
    component: () => import('@/views/staff/employee/employee-list/EmployeeList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.EMPLOYEES,
    },
  },
  {
    path: '/staff/employee/:id',
    name: 'staff-employee-view',
    component: () => import('@/views/staff/employee/employee-view/EmployeeView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.EMPLOYEES,
      breadCrumb(context) {
        return [
          {
            text: 'employees',
            useI18n: true,
            to: { name: 'staff-employee-list' },
          },
          {
            text: context.employeeName,
            useI18n: false,
          },
        ]
      },
    },
  },
  comingSoonRoute({
    path: '/staff/working-time-records',
    name: 'staff-working-time-records',
    comingSoonKey: 'staffWorkingTimeRecords',
    resource: PRIVATE.STAFF.WORKING_TIME_RECORDS,
  }),
  {
    path: '/staff/workstations',
    name: 'staff-workstations-list',
    component: () => import('@/views/staff/workstations/project-list/ProjectList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.PROJECTS,
    },
  },
  {
    path: '/staff/workstations/:id',
    name: 'staff-workstations-view',
    component: () => import('@/views/staff/workstations/project-view/ProjectView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.PROJECTS,
      breadCrumb(context) {
        return [
          {
            text: 'workstations',
            useI18n: true,
            to: { name: 'staff-workstations-list' },
          },
          {
            text: context.projectName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/staff/workstations/position/:id',
    name: 'staff-workstations-position-view',
    component: () => import('@/views/staff/workstations/project-view/project-position-view/PositionView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.PROJECTS,
      breadCrumb(context) {
        return [
          {
            text: 'workstations',
            useI18n: true,
            to: { name: 'staff-workstations-list' },
          },
          {
            text: context.projectName,
            useI18n: false,
            to: {
              name: 'staff-workstations-view',
              params: {
                id: context.projectId,
              },
            },
          },
          {
            text: context.positionName,
            useI18n: false,
          },
        ]
      },
    },
  },
]

export default staff
